import axios from './HTTP'

export default {
  getForEntity (params, callback, errorCallback) {
    axios
      .get('/api/manager_notes.json', {
        params: {
          internal_notable_type: params.entityName,
          internal_notable_id: params.entityId
        }
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/manager_notes.json`, {
        internal_note: {
          type: params.entityName,
          id: params.entityId,
          text: params.text
        }
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

}
